// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"833":"ce672de2","913":"976d1643"}[chunkId] + ".chunk.css";
};